import { useEffect, useState } from "react";
import { CounterTile, Skeleton } from "@/components/reusable";
import { fetchWorkDoneCounters } from "@/services/analyticsApi";
import type { WorkDoneCounter } from "@/types/analytics";

/**
 * Row of cumulative "work done" tiles. Deliberately no hours/£ saved —
 * clients can infer value from throughput without us fabricating a number.
 */
export function WorkDoneCounters() {
  const [data, setData] = useState<WorkDoneCounter[] | null>(null);

  useEffect(() => {
    let active = true;
    fetchWorkDoneCounters().then((d) => {
      if (active) setData(d);
    });
    return () => {
      active = false;
    };
  }, []);

  if (!data) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="bg-white border border-[var(--color-border-light)] rounded-[10px] p-4 flex flex-col gap-2"
          >
            <Skeleton width="w-24" height="h-2.5" />
            <Skeleton width="w-28" height="h-6" />
            <Skeleton height="h-6" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {data.map((c) => (
        <CounterTile
          key={c.id}
          label={c.label}
          value={c.value}
          sparklineValues={c.sparkline}
          unit={c.unit}
          format={c.value >= 10_000 ? "compact" : "full"}
        />
      ))}
    </div>
  );
}
